<template>
  <div>
    <div class="section regulatoryAffairs">
      <section class="section_slide-four">
        <div class="container-fluid">
          <h2 data-aos="fade-up">{{this.spectrum.tabs.title}}</h2>
          <p class="sub-heading" data-aos="fade-up">{{this.spectrum.tabs.richtext}}</p>
          <div class="tabs-wrapper">
            <div>
              <b-card no-body>
                <b-tabs card data-aos="fade-down">
                  <b-tab :title="this.spectrum.tabs.tabs_data[0].title" active>
                    <b-card-text>
                      <div class="accordion" role="tablist">
                        <div class="row">
                          <div class="col-lg-6">
                            <div class="map">
                                <img src="@/assets/images/svg/worldMap.svg" alt="" class="img-fluid">
                            </div>
                          </div>
                          <div class="col-lg-6">
                            <b-card no-body>
                              <b-card-header header-tag="header" role="tab">
                                <b-button block v-b-toggle.kuwait
                                  >{{this.spectrum.tabs.tabs_data[0].accordion[0].btn_text}}</b-button
                                >
                              </b-card-header>
                              <b-collapse
                                id="kuwait"
                                visible
                                accordion="my-accordion"
                                role="tabpanel"
                              >
                                <b-card-body>
                                  <ul>
                                    <li v-for="text in this.spectrum.tabs.tabs_data[0].accordion[0].list_data" :key="text" v-html="text"></li>
                                  </ul>
                                </b-card-body>
                              </b-collapse>
                            </b-card>
                            <b-card no-body>
                              <b-card-header header-tag="header" role="tab">
                                <b-button block v-b-toggle.JORDAN
                                  >{{this.spectrum.tabs.tabs_data[0].accordion[1].btn_text}}</b-button
                                >
                              </b-card-header>
                              <b-collapse
                                id="JORDAN"
                                accordion="my-accordion"
                                role="tabpanel"
                              >
                                <b-card-body>
                                  <div class="scrollWrapper">
                                    <scrollbar :ops="scrollSettings">
                                      <ul>
                                        <li v-for="text in this.spectrum.tabs.tabs_data[0].accordion[1].list_data" :key="text" v-html="text"></li>
                                      </ul>
                                    </scrollbar>
                                  </div>
                                </b-card-body>
                              </b-collapse>
                            </b-card>
                            <b-card no-body>
                              <b-card-header header-tag="header" role="tab">
                                <b-button block v-b-toggle.SAUDIARABIA
                                  >{{this.spectrum.tabs.tabs_data[0].accordion[2].btn_text}}</b-button
                                >
                              </b-card-header>
                              <b-collapse
                                id="SAUDIARABIA"
                                accordion="my-accordion"
                                role="tabpanel"
                              >
                                <b-card-body>
                                  <ul>
                                    <li v-for="text in this.spectrum.tabs.tabs_data[0].accordion[2].list_data" :key="text" v-html="text"></li>
                                  </ul>
                                </b-card-body>
                              </b-collapse>
                            </b-card>
                          </div>
                        </div>
                      </div>
                    </b-card-text>
                  </b-tab>
                  <b-tab :title="this.spectrum.tabs.tabs_data[1].title">
                    <b-card-text>
                      <div class="accordion" role="tablist">
                        <div class="row">
                          <div class="col-lg-6">
                            <div class="map">
                                <img src="@/assets/images/svg/worldMap.svg" alt="" class="img-fluid">
                            </div>
                          </div>
                          <div class="col-lg-6">
                            <b-card no-body>
                              <b-card-header header-tag="header" role="tab">
                                <b-button block v-b-toggle.SUDAN
                                  >{{this.spectrum.tabs.tabs_data[1].accordion[0].btn_text}}</b-button
                                >
                              </b-card-header>
                              <b-collapse
                                id="SUDAN"
                                visible
                                accordion="my-accordion"
                                role="tabpanel"
                              >
                                <b-card-body>
                                  <div class="scrollWrapper">
                                    <scrollbar :ops="scrollSettings">
                                      <ul>
                                        <li v-for="text in this.spectrum.tabs.tabs_data[1].accordion[0].list_data" :key="text" v-html="text"></li>
                                      </ul>
                                    </scrollbar>
                                  </div>
                                </b-card-body>
                              </b-collapse>
                            </b-card>
                            <b-card no-body>
                              <b-card-header header-tag="header" role="tab">
                                <b-button block v-b-toggle.SOUTHSUDAN
                                  >{{this.spectrum.tabs.tabs_data[1].accordion[1].btn_text}}</b-button
                                >
                              </b-card-header>
                              <b-collapse
                                id="SOUTHSUDAN"
                                accordion="my-accordion"
                                role="tabpanel"
                              >
                                <b-card-body>
                                  <div class="scrollWrapper">
                                    <scrollbar :ops="scrollSettings">
                                      <ul>
                                       <li v-for="text in this.spectrum.tabs.tabs_data[1].accordion[1].list_data" :key="text" v-html="text"></li>
                                      </ul>
                                    </scrollbar>
                                  </div>
                                </b-card-body>
                              </b-collapse>
                            </b-card>
                          </div>
                        </div>
                      </div>
                    </b-card-text>
                  </b-tab>
                  <b-tab :title="this.spectrum.tabs.tabs_data[2].title">
                    <b-card-text>
                      <div class="accordion" role="tablist">
                        <div class="row">
                          <div class="col-lg-6">
                            <div class="map">
                                <img src="@/assets/images/svg/worldMap.svg" alt="" class="img-fluid">
                            </div>
                          </div>
                          <div class="col-lg-6">
                            <b-card no-body>
                              <b-card-header header-tag="header" role="tab">
                                <b-button block v-b-toggle.JORDAN
                                  >{{this.spectrum.tabs.tabs_data[2].accordion[0].btn_text}}</b-button
                                >
                              </b-card-header>
                              <b-collapse
                                id="JORDAN"
                                visible
                                accordion="my-accordion"
                                role="tabpanel"
                              >
                                <b-card-body>
                                  <div class="scrollWrapper">
                                    <scrollbar :ops="scrollSettings">
                                      <ul>
                                        <li v-for="text in this.spectrum.tabs.tabs_data[2].accordion[0].list_data" :key="text" v-html="text"></li>
                                      </ul>
                                    </scrollbar>
                                  </div>
                                </b-card-body>
                              </b-collapse>
                            </b-card>
                            <b-card no-body>
                              <b-card-header header-tag="header" role="tab">
                                <b-button block v-b-toggle.IRAQ>{{this.spectrum.tabs.tabs_data[2].accordion[1].btn_text}}</b-button>
                              </b-card-header>
                              <b-collapse
                                id="IRAQ"
                                accordion="my-accordion"
                                role="tabpanel"
                              >
                                <b-card-body>
                                  <div class="scrollWrapper">
                                    <scrollbar :ops="scrollSettings">
                                      <ul>
                                        <li v-for="text in this.spectrum.tabs.tabs_data[2].accordion[1].list_data" :key="text">{{text}}</li>
                                      </ul>
                                    </scrollbar>
                                  </div>
                                </b-card-body>
                              </b-collapse>
                            </b-card>
                            <b-card no-body>
                              <b-card-header header-tag="header" role="tab">
                                <b-button block v-b-toggle.BAHRAIN
                                  >{{this.spectrum.tabs.tabs_data[2].accordion[2].btn_text}}</b-button
                                >
                              </b-card-header>
                              <b-collapse
                                id="BAHRAIN"
                                accordion="my-accordion"
                                role="tabpanel"
                              >
                                <b-card-body>
                                  <div class="scrollWrapper">
                                    <scrollbar :ops="scrollSettings">
                                      <ul>
                                        <li v-for="text in this.spectrum.tabs.tabs_data[2].accordion[2].list_data" :key="text">{{text}}</li>
                                      </ul>
                                    </scrollbar>
                                  </div>
                                </b-card-body>
                              </b-collapse>
                            </b-card>
                          </div>
                        </div>
                      </div>
                    </b-card-text>
                  </b-tab>
                </b-tabs>
              </b-card>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="section">
      <div class="section_slide-three">
        <div class="h-100 slick-slider-wrapper">
          <VueSlickCarousel v-bind="sliderSettings" ref="carousel">
            <div class="slide" v-for="slide in this.spectrum.slider.slides" :key="slide">
              <div class="container h-100">
                <div
                  class="row h-100 align-center align-content-center col-gap-60 "
                >
                  <div class="col-lg-7">
                    <div class="infra-boxes">
                      <div class="row col-gap-50">
                        <div class="col-sm-6" data-aos="fade-up" v-for="boxes in slide.boxes" :key="boxes">
                          <div class="box">
                            <p v-html="boxes"></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-5">
                    <h4 data-aos="fade-down">{{slide.title}}</h4>
                    <div class="scrollWrapper">
                      <scrollbar :ops="scrollSettings">
                        <div class="scroll_pading">
                          <div class="desc" data-aos="fade-up">
                            <p v-for="desc in slide.paragraphs" :key="desc" >{{desc}}</p>
                          </div>
                        </div>
                      </scrollbar>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </VueSlickCarousel>
          <div class="slider__nav">
            <button
              @click.prevent="$refs.carousel.prev()"
              class="slider__nav--previous disabled"
            >
              <svg
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 35 64.806"
              >
                <g id="glanceNext">
                    <g id="next" transform="translate(-117.742 0)" opacity="1">
                        <g id="Group_1" data-name="Group 1" transform="translate(117.742 0)">
                        <path id="Path_1" data-name="Path 1" d="M152,30.625,122.029.733a2.512,2.512,0,0,0-3.548,3.558L146.672,32.4,118.48,60.516a2.512,2.512,0,0,0,3.548,3.557L152,34.182a2.511,2.511,0,0,0,0-3.557Z" transform="translate(-117.742 0)" fill="#fff"/>
                        </g>
                    </g>
                </g>
              </svg>
            </button>
            <button
              @click.prevent="$refs.carousel.next()"
              class="slider__nav--next"
            >
              <svg
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 35 64.806"
              >
                <use xlink:href="#glanceNext"></use>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
export default {

  props: {
    sliderSettings: Object,
    scrollSettings: Object,
    spectrum:Object,
  },
  components: {
    VueSlickCarousel,
  },
  methods:{
  }
};
</script>


<style lang="scss" scoped></style>
